import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { DrawerService } from './services/drawer.service';
import { TitleService } from './services/title.service';

@Component({
  selector: 'main[app-root]',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  constructor(
    private titleService: TitleService,
    private router: Router,
    private dialog: MatDialog,
    private drawerService: DrawerService
  ) { }

  ngOnInit() {
    this.titleService.initGlobalStructuredData();
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      // 获取当前页面的纯路径（去除查询参数等）并拼接主域名
      const cleanUrl = this.router.url.split('?')[0];
      this.titleService.setCanonicalURL(cleanUrl);
      this.titleService.setRouteSeo(cleanUrl);
    });
  }
}
